import React from 'react';

export const name = 'help';

export const Help = () => (
  <svg viewBox="0 0 24 24" color="inherit" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.2246 14.124H10.8281V14.0312C10.8379 12.2197 11.375 11.668 12.2832 11.1113C12.8643 10.75 13.3184 10.2373 13.3184 9.50977C13.3184 8.64551 12.6445 8.09375 11.8145 8.09375C11.0674 8.09375 10.3301 8.54785 10.2715 9.58301H8.78711C8.85059 7.8252 10.1689 6.86328 11.8145 6.86328C13.6064 6.86328 14.8076 7.9375 14.8076 9.52441C14.8076 10.623 14.2705 11.3652 13.3965 11.8926C12.5664 12.4053 12.2441 12.9082 12.2246 14.0312V14.124ZM12.542 16.1162C12.542 16.6582 12.0977 17.0928 11.5654 17.0928C11.0283 17.0928 10.5889 16.6582 10.5889 16.1162C10.5889 15.584 11.0283 15.1445 11.5654 15.1445C12.0977 15.1445 12.542 15.584 12.542 16.1162Z"
    />
  </svg>
);
